import { ArrowRight, MessageCircle } from "lucide-react";
import { Reveal } from "./Reveal";
import { useSiteSettings } from "@/hooks/useSiteSettings";

export const FinalCta = () => {
  const site = useSiteSettings();
  return (
    <section id="cta" className="bg-ink pb-20 pt-4 md:pb-28" data-testid="final-cta-section">
      <div className="mx-auto max-w-7xl px-6 md:px-10">
        <Reveal>
          <div className="rounded-3xl bg-amber px-8 py-14 text-center md:px-14 md:py-20" data-testid="final-cta-card">
            <h2 className="mx-auto max-w-3xl font-display text-3xl font-extrabold uppercase leading-[1.06] tracking-tight text-white sm:text-5xl" data-testid="final-cta-headline">
              You work for money. Now make your property work for you.
            </h2>
            <p className="mx-auto mt-6 max-w-xl text-base leading-relaxed text-white/85 md:text-lg">
              Explore premium property opportunities with Urban Veera. For
              project details, eligibility and the complete structure:
            </p>
            <div className="mt-9 flex flex-wrap items-center justify-center gap-4">
              <a
                href="#contact-form"
                data-testid="final-cta-primary"
                className="group flex items-center gap-2.5 rounded-full bg-ink px-8 py-4 text-sm font-bold text-white transition-colors duration-300 hover:bg-navy"
              >
                Get in Touch With Our Team
                <ArrowRight size={16} className="transition-transform duration-300 group-hover:translate-x-1" />
              </a>
              <a
                href={`https://wa.me/${site.whatsapp}`}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="final-cta-whatsapp"
                className="flex items-center gap-2.5 rounded-full border-2 border-white/50 px-8 py-4 text-sm font-bold text-white transition-colors duration-300 hover:border-white hover:bg-white hover:text-amberdark"
              >
                <MessageCircle size={16} />
                WhatsApp Urban Veera
              </a>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
